import { render, staticRenderFns } from "./LatestQuotation.vue?vue&type=template&id=7af9d8b4&scoped=true"
import script from "./LatestQuotation.vue?vue&type=script&lang=js"
export * from "./LatestQuotation.vue?vue&type=script&lang=js"
import style0 from "./LatestQuotation.vue?vue&type=style&index=0&id=7af9d8b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9d8b4",
  null
  
)

export default component.exports